/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index";
// import Profile from "views/examples/Profile";
// import Maps from "views/examples/Maps";
// import Register from "views/pages/Register";
// import Login from "views/pages/Login";
// import Tables from "views/examples/Tables";
// import Icons from "views/examples/Icons";
import Profile from "views/pages/Profile";
import ManageUsers from "views/ManagePages/ManageUsers";
import Community from "views/pages/Community"
import ManageCommunity from "views/ManagePages/ManageCommunity";
import WorkActivities from "views/pages/WorkActivities";
import ManageCoachTutorAvailability from "views/ManagePages/ManageCoachTutorAvailability";
import ManageTutorRequests from "views/ManagePages/ManageTutorRequests";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/admin"
  },
  {
    path: "/manage-users",
    name: "Manage Users",
    icon: "fas fa-user text-info",
    component: ManageUsers,
    layout: "/admin"
  },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   icon: "ni ni-pin-3 text-orange",
  //   component: Maps,
  //   layout: "/admin"
  // },
  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   icon: "ni ni-single-02 text-yellow",
  //   component: Profile,
  //   layout: "/admin"
  // },
  // {
  //   path: "/tables",
  //   name: "Secondary Essays",
  //   icon: "ni ni-bullet-list-67 text-red",
  //   component: Tables,
  //   layout: "/admin"
  // },
  {
    path: "/manage-coach-tutor-availability",
    name: "Manage Coach Tutor Availability",
    icon: "fas fa-calendar-alt text-pink",
    component: ManageCoachTutorAvailability,
    layout: "/admin"
  },

  {
    path: "/manage-tutor-requests",
    name: "Manage Tutor Requests",
    icon: "fas fa-calendar-alt text-yellow",
    component: ManageTutorRequests,
    layout: "/admin"
  },

   {
    path: "/manage-community",
    name: "Manage Community",
    icon: "fas fa-users text-warning",
    component: Community,
    layout: "/admin",
    items:[
      {
        path: "/community-page",
        name: "Community Page",
       icon: "fas fa-users text-warning",
        component: Community,
        layout: "/admin"
      },
       {
      path: "/community-settings",
      name: "Community Settings ",
      icon: "fas fa-cog text-green",
      component: ManageCommunity,
      layout: "/admin"
    },
    ]
  },
  {
    path: "/community-page",
    name: "Community Page",
     icon: "fas fa-users text-warning",
    component: Community,
    layout: "/admin"
  },
  {
    path: "/community-settings",
    name: "Community Settings",
    icon: "fas fa-cog text-green",
    component: ManageCommunity,
    layout: "/admin"
  },

  //   {
  //   path: "/manage-tpc-courses",
  //   name: "Manage TPC Courses",
  //   icon: "ni ni-books text-primary",
  //   component: ManageTpcCourses,
  //   layout: "/admin"
  // },
  
  

  // {
  //   path: "/register",
  //   name: "Register",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: Register,
  //   layout: "/auth"
  // }
];
export default routes;
